const S3_PREFIXES = [
  "https://teckost.s3.amazonaws.com",
  "https://teckost.s3.ap-south-1.amazonaws.com",
];

const getCloudfrontBase = () =>
  String(process.env.REACT_APP_CLOUDFRONT_URL || "https://dgcqmelvtrzv6.cloudfront.net").replace(
    /\/+$/,
    "",
  );

const replaceS3WithCloudfront = (raw, cloudfrontUrl) => {
  if (!cloudfrontUrl) return raw;

  for (const prefix of S3_PREFIXES) {
    if (raw.includes(prefix)) {
      return raw.replace(prefix, cloudfrontUrl);
    }
  }

  if (/https?:\/\/teckost\.s3[.-][^/]+\.amazonaws\.com/i.test(raw)) {
    const path = raw.replace(/^https?:\/\/[^/]+/i, "");
    return `${cloudfrontUrl}${path}`;
  }

  return raw;
};

export const resolveMediaUrl = (value) => {
  if (!value) return "";

  const raw = String(value).trim();
  if (!raw) return "";

  const cloudfrontUrl = getCloudfrontBase();
  if (cloudfrontUrl && raw.includes(cloudfrontUrl)) {
    return raw;
  }

  const s3Replaced = replaceS3WithCloudfront(raw, cloudfrontUrl);
  if (s3Replaced !== raw) {
    return s3Replaced;
  }

  if (/^https?:\/\/(uat\.)?bidz\.ai\//i.test(raw) && cloudfrontUrl) {
    const path = raw.replace(/^https?:\/\/[^/]+\//i, "").replace(/^media\//, "");
    return `${cloudfrontUrl}/${path}`;
  }

  if (/^https?:\/\//i.test(raw) || raw.startsWith("//")) {
    return raw.startsWith("//") ? `https:${raw}` : raw;
  }

  if (!cloudfrontUrl) {
    return raw;
  }

  const cleanPath = raw.replace(/^\/+/, "").replace(/^media\//, "");
  return `${cloudfrontUrl}/${cleanPath}`;
};

export const getUrlFileExtension = (url) => {
  if (!url) return "";

  const raw = String(url).trim();
  if (!raw) return "";

  const withoutQuery = raw.split("?")[0].split("#")[0];
  const parts = withoutQuery.split(".");
  if (parts.length < 2) return "";

  return parts[parts.length - 1].toLowerCase();
};

export const isPdfUrl = (url) => getUrlFileExtension(url) === "pdf";

export const isImageUrl = (url) => {
  const extension = getUrlFileExtension(url);
  return ["png", "jpg", "jpeg", "webp", "gif"].includes(extension);
};
